<!-- ============================================================== -->
<!-- sidebar -->
<!-- ============================================================== -->
<div class="user-profile" style="background: url(assets/images/user-info.jpg) no-repeat;">
  <!-- User profile image -->
  <div class="profile-text"><a [matMenuTriggerFor]="" class=""> {{sUtenteLogin}} <i class="ti-angle-down font-12 m-l-5"></i></a></div>
  <div class="profile-img"> <img src="assets/images/users/profile.png" alt="user"> </div>
</div>
 <mat-nav-list appAccordion>
   <mat-list-item appAccordionLink *ngFor="let menuitem of menuItems.getMenuitem()" routerLinkActive="selected" group="{{menuitem.state}}">
     <a class="" appAccordionToggle [routerLink]="['/', menuitem.state]" *ngIf="menuitem.type === 'link'">
       <mat-icon>{{ menuitem.icon }}</mat-icon>
       <span>{{ menuitem.name }}</span>
       <span fxFlex></span>
       <span class="label label-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
     </a>

   </mat-list-item>

 </mat-nav-list>
